<template>
    <form :action="env.moodle_login_urls[userData.school_id]" v-if="showForm" target="_blank" method="post">
        <input type="hidden" name="anchor" value="">
        <input type="hidden" name="username" :value="userData.moodle_login">
        <input type="hidden" name="password" :value="userData.moodle_password">
        <button class="button button--accent button--moodle">{{ $t('go_to_moodle') }}</button>
    </form>


<!--    lesson__moodle-->
<!--    class button--moodle-login-->
</template>

<script>
    import env from '../env'
    import { mapGetters } from 'vuex'

    export default {
        data: () => ({
            env
        }),
        computed: {
            ...mapGetters([
                "userData"
            ]),
            showForm() {
                return this.userData.moodle_login && this.userData.moodle_password ? true : false
            }
        }
    }
</script>

<style scoped>

</style>
